/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Use_Cases_Research_TitleInputs */

const en_directory_taxonomy_use_cases_research_title = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Research_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Research a topic`)
};

const zh_directory_taxonomy_use_cases_research_title = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Research_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`研究主题`)
};

/**
* | output |
* | --- |
* | "Research a topic" |
*
* @param {Directory_Taxonomy_Use_Cases_Research_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_use_cases_research_title = /** @type {((inputs?: Directory_Taxonomy_Use_Cases_Research_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Use_Cases_Research_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_use_cases_research_title(inputs)
	return zh_directory_taxonomy_use_cases_research_title(inputs)
});
export { directory_taxonomy_use_cases_research_title as "directory.taxonomy.use-cases.research.title" }